import { Model } from '../parents/model';

export class CountryModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_DIAL_CODE = 'dial_code';

  static ATTR_ALPHA_2 = 'alpha_2';

  static ATTR_ORIGINAL_NAME = 'original_name';

  static ATTR_IS_ACTIVE = 'is_active';

  static ATTR_IS_DEFAULT = 'is_default';

  get name() {
    return this.attributes[CountryModel.ATTR_NAME];
  }

  get dialCode() {
    return this.attributes[CountryModel.ATTR_DIAL_CODE];
  }

  get alpha2() {
    return this.attributes[CountryModel.ATTR_ALPHA_2];
  }

  get originalName() {
    return this.attributes[CountryModel.ATTR_ORIGINAL_NAME];
  }

  get isActive() {
    return this.attributes[CountryModel.ATTR_IS_ACTIVE];
  }

  get isDefault() {
    return this.attributes[CountryModel.ATTR_IS_DEFAULT];
  }
}
